// ** React Imports
import { useMemo, useContext } from "react";
import { useHistory } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import SelectorSelectMulti from "components/layout/DropdownSelectors/SelectorSelectMulti";

// ** Custom Hooks
import useFilterSex from "hooks/filters/useFilterSex";
import useQuery from "hooks/useQuery";

// ** Utils & Helpers
import { searchSexCustomSort } from "utils/searchSexCustomSort";
import generateQueryPath from "utils/generateQueryPath";

// ** Context
import authContext from "contexts/authContext";

// #####################################################

const useNearbySexSelector = () => {
	const { t } = useTranslation("common");
	const { push } = useHistory();

	const query = useQuery();
	const { sex: sexUrl } = query || {};

	const isAuth = useContext(authContext);

	const language = useSelector((state) => state.globalCommon.language);
	const userSearchSex = useSelector((state) => state.globalUser.searchSex);

	const initialFilterSex = useMemo(() => {
		if (sexUrl) {
			return sexUrl;
		} else if (sexUrl === "") {
			return "";
		} else if (
			userSearchSex &&
			Array.isArray(userSearchSex) &&
			userSearchSex.length > 0
		) {
			return [...userSearchSex].sort(searchSexCustomSort);
		}
		// return "woman-man-couple-transsexual";
		return "";
	}, [sexUrl, userSearchSex]);

	const filterSex = useFilterSex({
		initial: initialFilterSex,
		multiple: true,
	});

	const { items, selected, compute, isSelected } = filterSex;

	const renderMultipleSexSelector = (setFiltersOpen) => (
		<SelectorSelectMulti
			label={t("gender")}
			emptyText={t("common:any.2")}
			items={items}
			selected={selected}
			onAccept={(value) => {
				const to = generateQueryPath(`/nearby`, {
					...query,
					sex: compute.valueToUrl(value) || "", //"woman-man-couple-transsexual",
				});

				push(to);
				if (typeof setFiltersOpen === "function") {
					setFiltersOpen(false);
				}
			}}
			withMobileVersion
		/>
	);

	const sexFinal = useMemo(() => {
		if (sexUrl) {
			return sexUrl;
		} else if (sexUrl === "") {
			return "";
		} else if (isAuth && userSearchSex) {
			return [...userSearchSex].sort(searchSexCustomSort).join("-");
		}
		return ""; //"woman-man-couple-transsexual";
	}, [sexUrl, userSearchSex, isAuth, language]);

	// ** Filtr - Płeć
	const sexFilterData = useMemo(() => {
		const sexItemsText = () => {
			return sexFinal
				? sexFinal
						.split("-")
						.map((sexItem) => t(`common:sexOptions.${sexItem}`))
						.join(", ")
				: null;
		};
		return sexFinal /*&& sexFinal !== "woman-man-couple-transsexual"*/
			? {
					label: t("common:gender"),
					selected: sexItemsText(),
			  }
			: null;
	}, [sexFinal, language]);

	// #####################################################

	return {
		renderMultipleSexSelector,
		isSelected,
		sexFilterData,
	};
};

// #####################################################

export default useNearbySexSelector;

// #####################################################
